import { useSelector } from 'react-redux';
import APIIntegrationTab from './APIIntegrationTab';
import ShopifyIntegrationTab from './ShopifyIntegrationTab';
import FeatureNotSupportedDialog from '../../common/FeatureNotSupportedDialog';
import React from 'react';

const IntegrationsSection = () => {
  const user = useSelector((state) => state.org.org.user);
  const subscription = useSelector((state) => state.org.org.subscription);
  const isApiIntegrationEnabled = subscription?.features?.api_integration_enabled;
  const isShopifyIntegrationEnabled = subscription?.features?.enable_shopify_integration;

  return isApiIntegrationEnabled || isShopifyIntegrationEnabled ? (
    <>
      {isApiIntegrationEnabled && user?.is_admin && <APIIntegrationTab />}
      {isShopifyIntegrationEnabled && <ShopifyIntegrationTab />}
    </>
  ) : (
    <FeatureNotSupportedDialog title={'Integrations'} />
  );
};

export default IntegrationsSection;
